import React from 'react';
import LegalLayout, { LegalSection } from 'components/ui/LegalLayout';
import withPageOverride from './withPageOverride';

const TermsOfServiceDefault = () => (
    <LegalLayout title="Условия использования" lastUpdated="19 мая 2026 г.">
        <p>
            Настоящие Условия использования (далее — «Условия») регулируют отношения
            между пользователем и сервисом <strong>SecureAuth Enterprise</strong>
            (далее — «Сервис»). Регистрируясь или используя Сервис, пользователь
            подтверждает, что ознакомлен с настоящими Условиями и принимает их в
            полном объёме.
        </p>

        <LegalSection title="1. Предмет">
            <p>
                Сервис предоставляет инструменты для аутентификации, управления учётными
                записями, ролями и доступом к функциям информационных систем,
                интегрированных с SecureAuth.
            </p>
        </LegalSection>

        <LegalSection title="2. Регистрация и учётная запись">
            <ul className="list-disc pl-6 space-y-1">
                <li>пользователь обязан указывать достоверные сведения;</li>
                <li>пользователь несёт ответственность за сохранность пароля и обязан
                    немедленно сообщить о подозрении на компрометацию;</li>
                <li>создание учётных записей средствами автоматизации без согласия
                    администрации запрещено;</li>
                <li>один пользователь может иметь только одну активную учётную запись,
                    если иное не предусмотрено политиками организации.</li>
            </ul>
        </LegalSection>

        <LegalSection title="3. Права и обязанности пользователя">
            <p>Пользователь вправе:</p>
            <ul className="list-disc pl-6 space-y-1">
                <li>использовать Сервис в пределах предоставленных прав и ролей;</li>
                <li>изменять настройки своей учётной записи и интерфейса;</li>
                <li>в любой момент удалить учётную запись.</li>
            </ul>
            <p>Пользователь обязуется:</p>
            <ul className="list-disc pl-6 space-y-1">
                <li>не нарушать работоспособность Сервиса;</li>
                <li>не пытаться получить доступ к чужим аккаунтам или данным;</li>
                <li>не использовать Сервис для незаконной или вредоносной деятельности.</li>
            </ul>
        </LegalSection>

        <LegalSection title="4. Права и обязанности Сервиса">
            <ul className="list-disc pl-6 space-y-1">
                <li>обеспечивать доступность Сервиса в режиме, близком к 24/7
                    (за вычетом плановых работ);</li>
                <li>защищать данные пользователей в соответствии с{' '}
                    <a href="/privacy" className="text-primary underline">Политикой
                    конфиденциальности</a>;</li>
                <li>уведомлять о существенных изменениях функционала и условий;</li>
                <li>приостанавливать доступ при подозрении на нарушение Условий
                    или законодательства.</li>
            </ul>
        </LegalSection>

        <LegalSection title="5. Ограничение ответственности">
            <p>
                Сервис предоставляется по принципу «как есть» («AS IS»). Администрация
                не несёт ответственности за косвенные убытки, упущенную выгоду и
                последствия, связанные с использованием или невозможностью использования
                Сервиса, за исключением случаев, прямо предусмотренных законом.
            </p>
        </LegalSection>

        <LegalSection title="6. Интеллектуальная собственность">
            <p>
                Все материалы Сервиса, включая программный код, дизайн и торговые знаки,
                являются объектами интеллектуальной собственности и защищены
                законодательством. Использование без письменного согласия правообладателя
                запрещено.
            </p>
        </LegalSection>

        <LegalSection title="7. Изменение Условий">
            <p>
                Условия могут быть изменены в одностороннем порядке. Актуальная редакция
                публикуется на этой странице. Продолжение использования Сервиса после
                публикации изменений означает согласие с новой редакцией.
            </p>
        </LegalSection>

        <LegalSection title="8. Применимое право">
            <p>
                К отношениям, возникающим в связи с использованием Сервиса, применяется
                законодательство Российской Федерации. Споры разрешаются в порядке,
                установленном действующим законодательством.
            </p>
        </LegalSection>

        <LegalSection title="9. Контакты">
            <p>
                По вопросам, связанным с настоящими Условиями, обращайтесь через раздел{' '}
                <a href="/support" className="text-primary underline">Поддержка</a>.
            </p>
        </LegalSection>
    </LegalLayout>
);

export default withPageOverride('terms', TermsOfServiceDefault);
